import React, { useEffect, useState } from 'react';

import * as qs from 'query-string';

import Notes from './Notes/Notes';
import Discussion from './Discussion/Discussion';

const NotesAndDiscussions: React.FC = () => {
  const [type, setType] = useState('notes');

  useEffect(() => {
    const { section, lesson } = qs.parse(window.location.search);

    if (lesson && lesson !== 'null') {
      setType(section as string);
      return;
    }
    setType(null);
  }, [window.location.search]);

  return (
    <div id={'notes-and-discussion-id'} className={'dont-scroll'}>
      {type === 'notes' && <Notes />}
      {type === 'discussions' && <Discussion />}
    </div>
  );
};

export default NotesAndDiscussions;
